import { render, staticRenderFns } from "./EpotTable.vue?vue&type=template&id=35b72868&"
import script from "./EpotTable.vue?vue&type=script&lang=js&"
export * from "./EpotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports